/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/arrow-down
 */
import { default as DefaultIcon } from '~icons/lucide/arrow-down';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ArrowDownIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
